import React from 'react'
import styles from './index.module.scss'

export default class Mask extends React.PureComponent {
  state = {
    spotlightStyle: {
      backgroundImage: 'radial-gradient(circle, transparent 100px, rgba(0,0,0,.85) 120px)'
    }
  }

  updateSpotlight = (e, size) => {
    this.setState({
      spotlightStyle: {
        backgroundImage: `radial-gradient(circle at ${e.offsetX}px ${e.offsetY}px, ${size}`
      }
    })
  }

  handleMouseMove = (e) => {
    this.updateSpotlight(e.nativeEvent, 'transparent 80px, rgba(0, 0, 0, 0.85) 100px)')
  }

  render () {
    const { children } = this.props
    const { spotlightStyle } = this.state

    return (
      <div className={styles.wrap}>
        {children}
        <div className={styles.mask} onMouseMove={this.handleMouseMove} style={spotlightStyle}></div>
      </div>
    )
  }
}